import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdAppGroupPermissionSetsDuplicatePermissionSetCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/app_group_permission_sets/all_permission_sets",
];
